import state from './integrator.state'
import mutations from './integrator.mutations'
import actions from './integrator.actions'

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
